import React from "react";
import {SecondLayerNavigation} from "../../../helpers/Menu";
import {MERCHANT_TERMINAL_SUBMENU} from "../../../../constants/links";

import Dashboard from "./components/Dashboard";
import TerminalsTrxHistory from "./components/TerminalsTrxHistory";
import TerminalsList from "./components/TerminalsList";
import TerminalsBuy from "./components/TerminalsBuy";

module.exports = () => {
  return (
    <SecondLayerNavigation
      links={MERCHANT_TERMINAL_SUBMENU}
      views={{
        terminalsDashboard: Dashboard,
        terminalsHistory: TerminalsTrxHistory,
        terminalsList: TerminalsList,
        terminalsBuy: TerminalsBuy
      }}
    />
  )
}
